import ArrowPuzzle from './arrow-puzzle.webp'
import ArrowPuzzleFod from './arrow-puzzle_fod.webp'
import BreakALuckyEggBrainrots from './break-a-lucky-egg-brainrots.webp'
import BreakALuckyEggBrainrotsFod from './break-a-lucky-egg-brainrots_fod.webp'
import BubblePopLegend from './bubble-pop-legend.webp'
import BubblePopLegendFod from './bubble-pop-legend_fod.webp'
import ElementalMonstersMerge from './elemental-monsters-merge.webp'
import ElementalMonstersMergeFod from './elemental-monsters-merge_fod.webp'
import FindTheFrogHiddenObjects from './find-the-frog--hidden-objects.webp'
import FindTheFrogHiddenObjectsFod from './find-the-frog--hidden-objects_fod.webp'
import GoodSortMaster from './good-sort-master.webp'
import GoodSortMasterFod from './good-sort-master_fod.webp'
import Hedgies from './hedgies.webp'
import HedgiesFod from './hedgies_fod.webp'
import HiddenObjectMyHotel from './hidden-object-my-hotel.webp'
import HiddenObjectMyHotelFod from './hidden-object-my-hotel_fod.webp'
import HiddenObjectStreetOfSecrets from './hidden-object-street-of-secrets.webp'
import HiddenObjectStreetOfSecretsFod from './hidden-object-street-of-secrets_fod.webp'
import IdolLivestreamDollDressUp from './idol-livestream-doll-dress-up.webp'
import IdolLivestreamDollDressUpFod from './idol-livestream-doll-dress-up_fod.webp'
import MahjongClassic from './mahjong-classic.webp'
import MahjongClassicFod from './mahjong-classic_fod.webp'
import MasterChess from './master-chess.webp'
import MasterChessFod from './master-chess_fod.webp'
import MergeFight from './merge--fight.webp'
import MergeFightFod from './merge--fight_fod.webp'
import MillionaireLife from './millionaire-life.webp'
import MillionaireLifeFod from './millionaire-life_fod.webp'
import MyTownHomeFamilyPlayhouse from './my-town-home-family-playhouse.webp'
import MyTownHomeFamilyPlayhouseFod from './my-town-home-family-playhouse_fod.webp'
import NutsPuzzleSortByColor from './nuts-puzzle-sort-by-color.webp'
import NutsPuzzleSortByColorFod from './nuts-puzzle-sort-by-color_fod.webp'
import PieceOfCakeMergeBake from './piece-of-cake-merge--bake.webp'
import PieceOfCakeMergeBakeFod from './piece-of-cake-merge--bake_fod.webp'
import PlantsVsZombiesFusionEdition from './plants-vs-zombies-fusion-edition.webp'
import PlantsVsZombiesFusionEditionFod from './plants-vs-zombies-fusion-edition_fod.webp'
import PregnantMotherSimulator from './pregnant-mother-simulator.webp'
import PregnantMotherSimulatorFod from './pregnant-mother-simulator_fod.webp'
import RobbyDoubleJumpForBrainrots from './robby-double-jump-for-brainrots.webp'
import RobbyDoubleJumpForBrainrotsFod from './robby-double-jump-for-brainrots_fod.webp'
import TbWorld from './tb-world.webp'
import TbWorldFod from './tb-world_fod.webp'
import WordFinder from './word-finder.webp'
import WordFinderFod from './word-finder_fod.webp'

export const topPlaygamaArt: Record<string, { image: string; fod: string; color: string }> = {
    'arrow-puzzle': { image: ArrowPuzzle, fod: ArrowPuzzleFod, color: '#1E82FF' },
    'break-a-lucky-egg-brainrots': {
        image: BreakALuckyEggBrainrots,
        fod: BreakALuckyEggBrainrotsFod,
        color: '#3AEDFF',
    },
    'bubble-pop-legend': { image: BubblePopLegend, fod: BubblePopLegendFod, color: '#DD7BFF' },
    'elemental-monsters-merge': { image: ElementalMonstersMerge, fod: ElementalMonstersMergeFod, color: '#1E82FF' },
    'find-the-frog--hidden-objects': {
        image: FindTheFrogHiddenObjects,
        fod: FindTheFrogHiddenObjectsFod,
        color: '#BEFF00',
    },
    'good-sort-master': { image: GoodSortMaster, fod: GoodSortMasterFod, color: '#d07ffe' },
    hedgies: { image: Hedgies, fod: HedgiesFod, color: '#DD7BFF' },
    'hidden-object-my-hotel': { image: HiddenObjectMyHotel, fod: HiddenObjectMyHotelFod, color: '#b03ff1' },
    'hidden-object-street-of-secrets': {
        image: HiddenObjectStreetOfSecrets,
        fod: HiddenObjectStreetOfSecretsFod,
        color: '#FFE900',
    },
    'idol-livestream-doll-dress-up': {
        image: IdolLivestreamDollDressUp,
        fod: IdolLivestreamDollDressUpFod,
        color: '#DD7BFF',
    },
    'mahjong-classic': { image: MahjongClassic, fod: MahjongClassicFod, color: '#3AEDFF' },
    'master-chess': { image: MasterChess, fod: MasterChessFod, color: '#45DAFF' },
    'merge--fight': { image: MergeFight, fod: MergeFightFod, color: '#BEFF00' },
    'millionaire-life': { image: MillionaireLife, fod: MillionaireLifeFod, color: '#e7572b' },
    'my-town-home-family-playhouse': {
        image: MyTownHomeFamilyPlayhouse,
        fod: MyTownHomeFamilyPlayhouseFod,
        color: '#c8ff00',
    },
    'nuts-puzzle-sort-by-color': { image: NutsPuzzleSortByColor, fod: NutsPuzzleSortByColorFod, color: '#3AEDFF' },
    'piece-of-cake-merge--bake': { image: PieceOfCakeMergeBake, fod: PieceOfCakeMergeBakeFod, color: '#fff200' },
    'plants-vs-zombies-fusion-edition': {
        image: PlantsVsZombiesFusionEdition,
        fod: PlantsVsZombiesFusionEditionFod,
        color: '#BEFF00',
    },
    'pregnant-mother-simulator': { image: PregnantMotherSimulator, fod: PregnantMotherSimulatorFod, color: '#F977FF' },
    'robby-double-jump-for-brainrots': {
        image: RobbyDoubleJumpForBrainrots,
        fod: RobbyDoubleJumpForBrainrotsFod,
        color: '#1E82FF',
    },
    'tb-world': { image: TbWorld, fod: TbWorldFod, color: '#1aff00' },
    'word-finder': { image: WordFinder, fod: WordFinderFod, color: '#FFE900' },
}
